/* src/app/system-utils/expanse-panel/expanse-panel.component.scss */
.panel-main {
  margin: 20px;
}
.panel-content {
  display: flex;
  flex-direction: column;
  border: solid 1px #ccc;
  padding: 10px;
  border-radius: 4px;
  position: relative;
}
.panel-header {
  position: absolute;
  top: -11px;
  font-weight: 700;
  font-size: 14px;
  padding-left: 10px;
  background-color: var(--tem-bg);
  cursor: pointer;
}
.system-main__icon {
  margin-right: 10px;
  margin-left: 10px;
}
.panel-text {
  display: flex;
  overflow: hidden;
  flex-direction: column;
  padding-top: 10px;
}
/*# sourceMappingURL=expanse-panel.component.css.map */
